export default {
    change_username_title: "Change Username",
    change_username_sim_details_error: "It was not possible to get the detail of the sim",
    change_username_saved_successfully: "Saved Successfully",
    change_username_the_was_an_error_in_the_save: "There was an error in the save",
    change_username_current_username: "Current Username",
    change_username_new_username: "New Username",
    change_username_sim_provider_account: "SIM Provider Account",
    change_username_sim_sim_phone: "Sim Phone",
    change_username_load_phone_number: "Load Phone #",
    change_username_iccid_minlength: "ICCID should be 14-20 characters",
    change_username_new_username_error_min: 'The new username must contain minimum chars',
    change_username_new_username_error_max: 'The new username must contain maximum chars',
    change_username_the_username_already_exist: 'The username already exists',
}